'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatListBulleted = function MdFormatListBulleted(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 8.4h23.4v3.2h-23.4v-3.2z m0 13.2v-3.2h23.4v3.2h-23.4z m0 10v-3.2h23.4v3.2h-23.4z m-5-3.8q1 0 1.6 0.6t0.7 1.6-0.7 1.6-1.6 0.6-1.5-0.6-0.6-1.6 0.6-1.6 1.5-0.6z m0-20.3q1.1 0 1.8 0.7t0.7 1.8-0.7 1.8-1.8 0.7-1.7-0.7-0.8-1.8 0.8-1.8 1.7-0.7z m0 10q1.1 0 1.8 0.7t0.7 1.8-0.7 1.8-1.8 0.7-1.7-0.7-0.8-1.8 0.8-1.8 1.7-0.7z' })
        )
    );
};

exports.default = MdFormatListBulleted;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-list-bulleted.js
// module id = 1555
// module chunks = 168707334958949